/* Daily Bag back-in-stock UI. Leaves option order untouched. */
(() => {
  function init(root) {
    if (!root || root.dataset.dbBisReady === 'true') return;
    const widget = root.querySelector('[data-db-bis]');
    if (!widget) return;
    let data;
    try { data = JSON.parse(widget.querySelector('[data-db-bis-product-json]').textContent); }
    catch (e) { return; }
    const variants = data.variants || [];
    const sectionId = widget.dataset.dbBisSection;
    const picker = root.querySelector('.product-detail__information variant-radios-detail, .product-detail__information variant-group-detail');
    const mainForm = root.querySelector('#product-form-' + CSS.escape(sectionId));
    const mobileForm = root.querySelector('form[id^="product-form-"]:not(#product-form-' + CSS.escape(sectionId) + ')');
    const backdrop = widget.querySelector('[data-db-bis-backdrop]');
    const dialog = widget.querySelector('.db-bis__dialog');
    const modalForm = widget.querySelector('form');
    let previouslyFocused = null;
    let mainVariant = null;
    let mobileVariant = null;
    root.dataset.dbBisReady = 'true';

    function variantById(id) { return variants.find(v => String(v.id) === String(id)) || null; }
    function selectedVariant() {
      if (!picker) return variantById(mainForm?.querySelector('[name="id"]')?.value);
      const selected = Array.from(picker.querySelectorAll('fieldset')).map(fieldset => {
        const radio = fieldset.querySelector('input[type="radio"]:checked');
        if (radio) return radio.value;
        const select = fieldset.querySelector('select');
        return select ? select.value : null;
      });
      if (selected.length === 0) return variantById(mainForm?.querySelector('[name="id"]')?.value);
      return variants.find(variant => selected.every((value, index) => value === null || variant.options[index] === value)) || null;
    }
    function availabilityForm(form, variant, isMain) {
      if (!form) return;
      const buttons = form.querySelector('.product-form__buttons');
      if (!buttons) return;
      let notify = buttons.querySelector('.db-bis-notify-trigger');
      if (!notify) {
        notify = document.createElement('button');
        notify.type = 'button';
        notify.className = 'db-bis-notify-trigger';
        notify.textContent = 'NOTIFY ME WHEN AVAILABLE';
        buttons.appendChild(notify);
        notify.addEventListener('click', () => showModal(variantById(notify.dataset.variantId)));
      }
      const out = !variant || !variant.available;
      notify.classList.toggle('db-bis-notify-trigger--visible', out && !!variant);
      notify.dataset.variantId = variant ? variant.id : '';
      const add = form.querySelector('[name="add"]');
      const label = add?.querySelector('.btn-label');
      if (out) {
        if (add) add.disabled = true;
        if (label) label.textContent = variant ? 'OUT OF STOCK' : 'UNAVAILABLE';
      } else if (!isMain) {
        if (add) add.disabled = false;
        if (label) label.textContent = window.variantStrings?.addToCart || 'Add to Cart';
      }
      const accelerated = form.querySelector('.btn-checkout-dynamic');
      if (accelerated) accelerated.style.display = out ? 'none' : '';
    }
    function updateMain() { mainVariant = selectedVariant(); availabilityForm(mainForm, mainVariant, true); }
    function updateMobile() {
      const id = mobileForm?.querySelector('[name="id"]')?.value;
      mobileVariant = variantById(id);
      availabilityForm(mobileForm, mobileVariant, false);
    }
    function fmt(cents) {
      if (window.Shopify?.formatMoney && window.themeGlobalVariables?.settings?.money_format) {
        return window.Shopify.formatMoney(cents, window.themeGlobalVariables.settings.money_format);
      }
      return (Number(cents) / 100).toFixed(2) + ' ' + (widget.dataset.dbBisCurrency || 'EGP');
    }
    function showModal(variant) {
      if (!variant || variant.available) return;
      const image = widget.querySelector('[data-db-bis-image]');
      let img = variant.featured_image?.src || data.featured_image;
      if (img && typeof img === 'object') img = img.src;
      if (img) { image.src = img; image.hidden = false; }
      else image.hidden = true;
      image.alt = data.title || '';
      widget.querySelector('[data-db-bis-name]').textContent = data.title || '';
      widget.querySelector('[data-db-bis-variant]').textContent = (data.options || []).map((key, i) => key + ': ' + (variant.options[i] || '')).join(' · ');
      const price = widget.querySelector('[data-db-bis-price]');
      price.textContent = (variant.compare_at_price && variant.compare_at_price > variant.price ? fmt(variant.compare_at_price) + '  →  ' : '') + fmt(variant.price);
      const url = new URL(widget.dataset.dbBisUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      widget.querySelector('[data-db-bis-message]').value = 'Back in stock request\nProduct: ' + data.title + '\nVariant: ' + variant.title + '\nVariant ID: ' + variant.id + '\nProduct URL: ' + url.toString() + '\nPlease notify me when this exact variant is available.';
      previouslyFocused = document.activeElement;
      backdrop.hidden = false;
      document.body.classList.add('db-bis-dialog-open');
      dialog.focus();
    }
    function hideModal() {
      backdrop.hidden = true;
      document.body.classList.remove('db-bis-dialog-open');
      if (previouslyFocused && previouslyFocused.isConnected) previouslyFocused.focus();
    }
    widget.querySelectorAll('[data-db-bis-close]').forEach(btn => btn.addEventListener('click', hideModal));
    backdrop.addEventListener('click', e => { if (e.target === backdrop) hideModal(); });
    document.addEventListener('keydown', e => {
      if (backdrop.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); hideModal(); }
      if (e.key === 'Tab') {
        const focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), textarea:not(:disabled)')).filter(el => el.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Prevent unavailable variants from ever being added to cart.
    root.addEventListener('submit', event => {
      if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
      const form = event.target;
      const variant = form === mainForm ? selectedVariant() : variantById(form.querySelector('input[name="id"]')?.value);
      if (!variant?.available) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    if (picker) picker.addEventListener('change', () => { queueMicrotask(updateMain); requestAnimationFrame(updateMain); });
    root.addEventListener('change', e => {
      if (mobileForm && mobileForm.contains(e.target) && e.target.name === 'id') requestAnimationFrame(updateMobile);
    });
    root.querySelectorAll('[data-db-option-value]').forEach(btn => btn.addEventListener('click', () => requestAnimationFrame(updateMobile)));
    // When the native theme syncs the mobile drawer later, keep it in step.
    root.addEventListener('click', e => { if (e.target.closest('[data-db-sticky-open]')) requestAnimationFrame(updateMobile); });
    updateMain(); updateMobile();
    if (widget.querySelector('[data-db-bis-success], [data-db-bis-errors]')) {
      const fallback = variants.find(v => !v.available);
      if (fallback) showModal(fallback);
    }
  }
  function initAll() { document.querySelectorAll('.main-product-section [id^="MainProduct-"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
